import type { CampaignPriceResult } from '../campaign-price'

export interface BuyMoreSaveMorePriceParams {
  originalPrice: number
  maxPromotionAmount: number
  campaignPercent: number
  isCampaignActive: boolean
}

/**
 * Tính giá cho campaign buy_more_save_more
 * Logic gốc không thay đổi
 * - Nếu max_promotion_amount = 0 thì không giảm, giữ nguyên giá gốc
 * - Nếu max_promotion_amount > 0 thì chỉ giảm cho item có giá gốc <= max_promotion_amount
 */
export function calculateBuyMoreSaveMorePrice({
  originalPrice,
  maxPromotionAmount,
  campaignPercent,
  isCampaignActive,
}: BuyMoreSaveMorePriceParams): CampaignPriceResult {
  let finalPrice = originalPrice
  let discountPercent = 0

  // Nếu max_promotion_amount = 0 thì không giảm, giữ nguyên giá gốc
  // Nếu max_promotion_amount > 0 thì chỉ giảm cho item có giá gốc <= max_promotion_amount
  if (
    isCampaignActive &&
    campaignPercent > 0 &&
    maxPromotionAmount > 0 &&
    originalPrice <= maxPromotionAmount
  ) {
    // Áp dụng giảm giá theo phần trăm campaign
    finalPrice = Math.round(originalPrice * (1 - Number(campaignPercent) / 100))
    // Làm tròn finalPrice tới hàng nghìn gần nhất
    finalPrice = Math.round(finalPrice / 1000) * 1000
  }

  // Tính phần trăm giảm giá dựa trên originalPrice và finalPrice
  discountPercent =
    originalPrice > 0
      ? Math.round(((originalPrice - finalPrice) / originalPrice) * 100)
      : 0

  // Chỉ sửa phần hiển thị: discountPercent không vượt quá campaignPercent
  // Không tính lại finalPrice, chỉ giới hạn discountPercent cho UI
  const displayDiscount =
    discountPercent > campaignPercent ? campaignPercent : discountPercent

  return {
    finalPrice,
    originalPrice,
    discountPercent: displayDiscount,
    shouldShowDiscount: displayDiscount > 0,
  }
}
